var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
import React, { Fragment } from "react";
import { artActionInfoCls, artActionInfoCommonCls, artActionInfoHighlightedCls, artActionInfoIconCls, artActionInfoTitleCls, artActionInfoContentCls, artActionInfoContentAdditionlCls } from "./Action.less";
var ArtActionInfo = /* @__PURE__ */ __name(function ArtActionInfo2(_ref) {
  var children = _ref.children;
  return /* @__PURE__ */ React.createElement("div", {
    className: artActionInfoCls
  }, children);
}, "ArtActionInfo");
var ArtActionInfoHighlighted = /* @__PURE__ */ __name(function ArtActionInfoHighlighted2(_ref2) {
  var icon = _ref2.icon, title = _ref2.title, children = _ref2.children, additional = _ref2.additional;
  return /* @__PURE__ */ React.createElement("div", {
    className: artActionInfoHighlightedCls
  }, /* @__PURE__ */ React.createElement("span", {
    className: artActionInfoIconCls
  }, icon), /* @__PURE__ */ React.createElement("span", {
    className: artActionInfoContentCls
  }, /* @__PURE__ */ React.createElement("span", {
    className: artActionInfoTitleCls
  }, title), children ? /* @__PURE__ */ React.createElement(Fragment, null, " - ", children) : null, additional ? /* @__PURE__ */ React.createElement("span", {
    className: artActionInfoContentAdditionlCls
  }, additional) : null));
}, "ArtActionInfoHighlighted");
var ArtActionInfoCommon = /* @__PURE__ */ __name(function ArtActionInfoCommon2(_ref3) {
  var icon = _ref3.icon, children = _ref3.children, additional = _ref3.additional;
  return /* @__PURE__ */ React.createElement("div", {
    className: artActionInfoCommonCls
  }, /* @__PURE__ */ React.createElement("span", {
    className: artActionInfoIconCls
  }, icon), /* @__PURE__ */ React.createElement("span", {
    className: artActionInfoContentCls
  }, children, additional ? /* @__PURE__ */ React.createElement("span", {
    className: artActionInfoContentAdditionlCls
  }, additional) : null));
}, "ArtActionInfoCommon");
export {
  ArtActionInfo,
  ArtActionInfoCommon,
  ArtActionInfoHighlighted
};
